// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[page-href]{cursor:pointer}", "",{"version":3,"sources":["webpack://./src/shared/framework/components/page/page-href/page-href.scss"],"names":[],"mappings":"AAAA,YAGC,cAAA","sourcesContent":["[page-href]\r\n{\r\n\t// Use cursor to indicate the element is clickable.\r\n\tcursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
